export const setRecentCalls = payload => ({
  type: 'SET_RECENT_CALLS',
  payload,
});
